import controller from './blog-detail.controller';
import templateBase from './templates/blog-detail-base.view.html';
import templateT1 from './templates/blog-detail-t1.view.html';
import templateT13 from './templates/blog-detail-t13.view.html';
import templateAD from './templates/blog-detail-adaptative.html';

let BlogDetailComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if(__env.adaptative) { return templateAD; }
    else{
        if(response.BLOG_DETAIL.component == 'template_t1'){return templateT1}
        if(response.BLOG_DETAIL.component == 'template_t13'){return templateT13}
        else {return templateBase;}
    }
}

export default BlogDetailComponent;


// WEBPACK FOOTER //
// ./www/components/blog/blog-detail/blog-detail.component.js